// src/components/Navbar.js
import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

const Navbar = ({ logo }) => {
  const { t, i18n } = useTranslation();
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);

  const isDrawingsPage = location.pathname === "/drawings";

  const logoSrc =
    logo || (isDrawingsPage ? "/assets/logo-black.png" : "/assets/logo-white.png");

  const changeLanguage = (e) => {
    i18n.changeLanguage(e.target.value);
    setIsOpen(false);
  };

  const textColor = isDrawingsPage ? "text-black" : "text-white";

  return (
    <nav className={`fixed top-0 left-0 w-full z-50 h-24 backdrop-blur-md bg-white/10 px-4 flex items-center justify-between ${textColor}`}>
      <Link to="/" className="flex items-center space-x-2">
        <img
          src={logoSrc}
          alt="Logo"
          className="max-h-20 w-auto object-contain"
        />
      </Link>

      {/* Hamburger Menü (Mobil) */}
      <button
        className="lg:hidden text-5xl p-2"
        onClick={() => setIsOpen(!isOpen)}
      >
        ☰
      </button>

      {/* Masaüstü Menü */}
      <div className={`hidden lg:flex gap-6 items-center text-base font-medium ${textColor}`}>
        <Link to="/products">{t("products.title")}</Link>
        <Link to="/drawings">{t("drawings.title")}</Link>
        <Link to="/contact">{t("contact.title")}</Link>
        <select
          onChange={changeLanguage}
          defaultValue={i18n.language}
          className="bg-gray-100 text-black border border-gray-300 rounded-full px-4 py-2 shadow-md hover:bg-gray-200 cursor-pointer focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all"
        >
          <option value="tr">TR</option>
          <option value="en">EN</option>
        </select>
      </div>

      {/* Mobil Menü */}
      {isOpen && (
        <div className="absolute top-24 left-0 w-full bg-black/90 text-white px-6 py-6 flex flex-col gap-6 text-lg font-semibold lg:hidden z-50">
          <Link to="/products" onClick={() => setIsOpen(false)}>{t("products.title")}</Link>
          <Link to="/drawings" onClick={() => setIsOpen(false)}>{t("drawings.title")}</Link>
          <Link to="/contact" onClick={() => setIsOpen(false)}>{t("contact.title")}</Link>
          <select
            onChange={changeLanguage}
            defaultValue={i18n.language}
            className="bg-gray-100 text-black text-lg border border-gray-300 rounded-full px-6 py-3 shadow-md hover:bg-gray-200 cursor-pointer focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all"
          >
            <option value="tr">TR</option>
            <option value="en">EN</option>
          </select>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
